<template>
  <v-dialog fullscreen v-model="showDetails">
    <v-sheet>
      <v-toolbar elevation="0">
        <v-toolbar-items>
          <v-btn icon @click="closeDetailsModal">
            <v-icon>panda-back</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-toolbar-title class="body-bold-small">
            {{ $t('message.pages.videoPage.details.videoInfo') }}
          </v-toolbar-title>
        </v-toolbar-items>
      </v-toolbar>
      <portal-target name="details--mobile"></portal-target>
    </v-sheet>
  </v-dialog>
</template>
<script>
export default {
  name: 'VideoDetailsMobile',
  props: {
    showDetails: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    closeDetailsModal() {
      this.$emit('closeDetailsModal')
    },
  },
}
</script>
<style lang="scss" scoped>
.v-sheet::v-deep {
  height: 100%;
  header .v-toolbar__content {
    padding: 0 $spacing-03;
    border-bottom: 1px solid varFigma(neutral-95-lightest);
    .v-toolbar__items {
      align-items: center;
      .v-toolbar__title {
        color: varFigma(neutral-20-dark);
      }
      .v-btn.v-btn--icon {
        color: varFigma(neutral-40-light);
      }
    }
  }
}
</style>
